import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react';

const FromOurAgents = () => {
  const [currentStory, setCurrentStory] = useState(0);

  const stories = [
    {
      name: 'COLIN ORTMEIER',
      title: 'KILOTERRA Land Specialist',
      yearsWithCompany: 'Since 2020',
      image: '/Colin Ortmeier.jpg',
      quote: 'Working at Kiloterra has been a game-changer for me both personally and professionally. The strong team culture here is unmatched — I\'m surrounded by motivated, supportive individuals who genuinely want to see each other succeed. The flexible schedule allows me to take control of my time and build a career that fits my lifestyle, whether I need to be on the road, in the treestand, or spending time with family. What truly sets KILOTERRA apart is the unlimited earning potential with the right mindset and work ethic.',
      achievement: 'First Year Top Producer'
    },
    {
      name: 'CHRIS WEARMOUTH',
      title: 'KILOTERRA Land Specialist',
      yearsWithCompany: 'Since 2021',
      image: '/Chris Wearmouth.jpg',
      quote: 'With professional marketing and admin support behind me, I spend more time prospecting new clients and less time chasing details. I can drop my kid at daycare, hit the gym at noon, and still crush my goals — this role lets me own my calendar, not the other way around.',
      achievement: 'Frequent Top Producer'
    },
    {
      name: 'SHANE SPYKSMA',
      title: 'KILOTERRA Land Specialist',
      yearsWithCompany: 'Since 2019',
      image: '/Shane Spyksma.jpg',
      quote: 'The team culture here is unmatched—everyone\'s truly pulling in the same direction. With the training and support behind me, I can focus on what I do best: selling land and building my business on my own terms.',
      achievement: 'Frequent Top 5 Producer'
    },
    {
      name: 'CHRIS JANIS',
      title: 'KILOTERRA Land Specialist',
      yearsWithCompany: 'Since 2022',
      image: '/Chris Janis.jpg',
      quote: 'Working with KILOTERRA has transformed my career and my life. The comprehensive training program and ongoing mentorship helped me achieve success I never thought possible in land sales.',
      achievement: 'First Year Top Producer'
    }
  ];

  const nextStory = () => {
    setCurrentStory((prev) => (prev + 1) % stories.length);
  };

  const prevStory = () => {
    setCurrentStory((prev) => (prev - 1 + stories.length) % stories.length);
  };

  return (
    <section id="testimonials" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 animate-slide-up">
          <div className="flex items-center justify-center mb-4">
            <Quote className="h-8 w-8 text-kiloterra-yellow mr-3" />
            <h2 className="text-4xl font-bold text-kiloterra-dark uppercase">
              From Our Agents
            </h2>
          </div>
        </div>

        {/* Written Testimonials Slider */}
        <div className="relative max-w-4xl mx-auto">
          <div className="bg-gray-50 p-8 lg:p-12 shadow-lg animate-fade-in">
            <div className="flex flex-col lg:flex-row items-center text-center lg:text-left">
              {/* Agent Photo */}
              <div className="flex-shrink-0 mb-6 lg:mb-0 lg:mr-8">
                <img
                  src={stories[currentStory].image}
                  alt={stories[currentStory].name}
                  className="w-32 h-32 object-cover border-4 border-kiloterra-dark"
                  loading="lazy"
                />
              </div>

              {/* Story Content */}
              <div className="flex-1">
                <blockquote className="text-xl text-gray-700 mb-6 italic leading-relaxed">
                  "{stories[currentStory].quote}"
                </blockquote>
                <div className="mb-4">
                  <div className="font-bold text-kiloterra-dark text-lg uppercase">
                    {stories[currentStory].name}
                  </div>
                  <div className="text-gray-600 uppercase">
                    {stories[currentStory].title}, {stories[currentStory].yearsWithCompany}
                  </div>
                </div>
                <div className="inline-block bg-kiloterra-yellow text-kiloterra-dark px-4 py-2 text-sm font-bold uppercase">
                  {stories[currentStory].achievement}
                </div>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div className="flex justify-center items-center mt-8 space-x-4">
            <button
              onClick={prevStory}
              className="p-2 bg-kiloterra-dark text-white hover:bg-opacity-80 transition-all duration-300"
            >
              <ChevronLeft className="h-6 w-6" />
            </button>

            <div className="flex space-x-2">
              {stories.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentStory(index)}
                  className={`w-3 h-3 transition-all duration-300 ${
                    index === currentStory ? 'bg-kiloterra-dark' : 'bg-gray-300'
                  }`}
                />
              ))}
            </div>

            <button
              onClick={nextStory}
              className="p-2 bg-kiloterra-dark text-white hover:bg-opacity-80 transition-all duration-300"
            >
              <ChevronRight className="h-6 w-6" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FromOurAgents;